<template>
  <Page back :label="page.titlePage">
    <template v-if="page.intro">
      <div v-if="page.intro.image" class="px-8">
        <img
          :src="page.intro.image"
          alt=""
          class="astra-image w-full rounded-12 object-cover block"
        />
      </div>
      <detail-section :label="page.intro.title">
        <p
          v-if="page.intro.subtitle"
          class="px-8 mt-0 mb-6 font-helvetica-ultralight text-24 line-28 text-mid-dark-grey"
        >
          {{ page.intro.subtitle }}
        </p>
        <read-more-text
          :short="page.intro.description_short"
          :html="page.intro.description"
        />
        <div v-if="page.intro.video?.url" class="px-8 mt-8">
          <video-preview
            :preview="page.intro.video.preview"
            @play="isVideoOpen = true"
          />
        </div>
      </detail-section>
    </template>

    <detail-section
      v-if="page.benefits?.items?.length"
      :label="page.benefits.title"
    >
      <benefits-card :items="page.benefits.items" />
    </detail-section>

    <detail-section v-if="page.whatIs" :label="page.whatIs.title">
      <read-more-text
        :short="page.whatIs.description_short"
        :html="page.whatIs.description"
      />
    </detail-section>

    <detail-section v-if="page.why" :label="page.why.title">
      <div v-if="page.why.image" class="px-8 mb-4">
        <img
          :src="page.why.image"
          alt=""
          class="astra-image w-full rounded-12 object-cover block"
        />
      </div>
      <read-more-text
        :short="page.why.description_short"
        :html="page.why.description"
      />
    </detail-section>

    <detail-section
      v-if="relatedProducts.length"
      :label="page.relatedProducts.title"
      noSeparator
    >
      <carousel id="astra-related-products" classes="-my-8 py-8">
        <div
          v-for="(product, i) in relatedProducts"
          :key="i"
          :class="[
            i === 0 ? 'ml-8' : '',
            product.id ? 'cursor-pointer' : 'pointer-events-none',
            'related-product mr-4 flex flex-col',
          ]"
          @click="openProduct(product)"
        >
          <img
            :src="product.image"
            alt=""
            class="related-product-image w-full rounded-12 object-cover elevated-shadow"
          />
          <span class="mt-3 font-helvetica text-16 line-24 text-black">
            {{ product.title }}
          </span>
        </div>
        <div>&nbsp;</div>
      </carousel>
    </detail-section>

    <video-modal
      file
      :video="page.intro?.video"
      :open="isVideoOpen"
      @onClose="isVideoOpen = false"
    />
  </Page>
</template>

<script>
import Page from "../components/Page.vue";
import Carousel from "../components/Carousel.vue";
import DetailSection from "../components/DetailSection.vue";
import ReadMoreText from "../components/ReadMoreText.vue";
import BenefitsCard from "../components/BenefitsCard.vue";
import VideoPreview from "../components/VideoPreview.vue";
import VideoModal from "../components/modals/VideoModal.vue";
import MatomoManager from "../mixins/MatomoManager.vue";
import urls from "@/urls";
import messages from "@/messages";

export default {
  name: "Astra",

  components: {
    Page,
    Carousel,
    DetailSection,
    ReadMoreText,
    BenefitsCard,
    VideoPreview,
    VideoModal,
  },

  mixins: [MatomoManager],

  data() {
    return {
      page: {},
      isVideoOpen: false,
    };
  },

  computed: {
    relatedProducts() {
      return this.page.relatedProducts?.products || [];
    },
  },

  created() {
    this.fetchPage();
  },

  methods: {
    async fetchPage() {
      try {
        this.page = await this.$http({
          method: "GET",
          url: urls.pages.astra,
        });
      } catch (e) {
        console.error(e);
        this.$toast({
          message: messages.errors.astra,
          color: "danger",
        });
      }
    },

    openProduct(product) {
      this.logEvent("Astra", "open Related Product", product.title);
      this.$router.push("/products/detail/" + product.id);
    },
  },
};
</script>

<style scoped>
.astra-image {
  height: 221px;
}

.related-product {
  width: 241px;
  min-width: 241px;
}

.related-product-image {
  height: 170px;
}
</style>
